import {URL_BASE_API } from '../configs/urlConfigs';

import service from './api';

export const validateClientAdd = (request) => {  
    const ENDPOINT = URL_BASE_API+'user/validate-add-client/?category='+request.data;
    return service.get(ENDPOINT);
}

export const validateClientDetails = (request) => {  
    const ENDPOINT = URL_BASE_API+'user/validate-client-details/'+request.data;
    return service.get(ENDPOINT);
}

export const validateEventAdd = (request) => {  
    const ENDPOINT = URL_BASE_API+'events/validate-add-event/';
    return service.get(ENDPOINT);
}

export const validateCrewAdd = (request) => {  
    const ENDPOINT = URL_BASE_API+'user/validate-add-crew/';
    return service.get(ENDPOINT);
}

export const validateCrewDetails = (request) => {  
    const ENDPOINT = URL_BASE_API+'user/validate-crew-details/'+request.data;
    return service.get(ENDPOINT);
}


